import { axiosInstanceLegacy } from "@/service/Axios";

import { LoginResponseT } from "./postLegacyLoginUser";

type postLegacyRefreshTokenResponse = LoginResponseT;

export const postLegacyRefreshToken = async (
  refreshToken: string,
): Promise<postLegacyRefreshTokenResponse> => {
  const { data } = await axiosInstanceLegacy.post<postLegacyRefreshTokenResponse>(
    `/api/authentication/refresh`,
    {
      refreshToken: refreshToken,
    },
  );

  return data;
};
